import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './api';
import { HStack, Box, Button, Heading, Text, Divider } from '@chakra-ui/react';

import { QRCodeCanvas } from 'qrcode.react';
import Share from './components/Share';
import DownloadPDF from './components/DownloadPDF';
import Footer from './components/Footer';
import SendEmailButton from './components/SendEmailButton';
import PrintQrCode from './components/PrintQrCode';

function CheckoutOK() {
  const isDemo = process.env.REACT_APP_IS_DEMO === 'true';

  const [user] = useAuthState(auth);
  const isAdmin = user?.displayName === 'admin';
  const isCashier = user?.displayName === 'cashier';

  const [error, setError] = useState('');
  const { orderId } = useParams();

  const domain =
    window.location.hostname === 'localhost'
      ? 'http://localhost:3000'
      : 'https://' + window.location.hostname;
  const url = `${domain}/order/${orderId}`;

  return (
    <Box w="100%">
      <Heading mt={5} color='white' fontSize={'2xl'}>
        Ordine completato!
      </Heading>
      <Text my={5} color='white' fontSize={'lg'}>
        Presentati agli stand con questo QR Code per ricevere il tuo ordine.
      </Text>
      <Text my={5} color='gold' fontSize={'lg'}>
        <b>IMPORTANTE</b>
        <br />
        Scarica il <b>QR Code</b> o fai uno <b>screenshot</b>&#160; per usarlo in un secondo
        momento.
      </Text>
      {/* <Text my={5} color='white' fontSize={'lg'}>
        Buon appetito!
      </Text> */}
      <Box
        w="100%"
        bg="white"
        py={8}
        display="flex"
        alignItems="center"
        flexDirection="column"
        borderRadius={10}
        border="3px solid teal"
        // boxShadow="0 0 10px 0 rgba(0, 0, 0, 0.1)"
      >
        <QRCodeCanvas size={256} value={url} />
      </Box>
      <Box display="flex" alignItems="center" flexDirection="column" mt={4}>
        <HStack>
          <DownloadPDF orderId={orderId} />
          <Share
            title='Ordine'
            text='Questo è il mio ordine ===>'
            url={window.location.href}
            onError={(err) => {
              setError(err.message);
            }}
          />
          {error && (
            <Text mt={10} color='tomato'>
              {error}
            </Text>
          )}
        </HStack>
        {isAdmin && <SendEmailButton orderId={orderId} />}
        {isCashier && (
          <PrintQrCode qrValue={url} text1={'Ricevuta ordine'} text2={orderId} withPreview={false} />
        )}
      </Box>

      <Text mt={10} color='white' fontSize={'lg'}>
        Codice Ordine
      </Text>
      <Text my={0} color='gold' fontSize={'lg'}>
        {orderId}
      </Text>
      {isCashier && (
        <HStack mt={10} justifyContent={'center'}>
          <Button as={Link} to={'/menu'}>
            Torna alla Cassa
          </Button>{' '}
        </HStack>
      )}
      {isDemo && (
        <>
          <Divider mt={10} />
          <HStack my={30}>
            <Text color={'white'} fontSize={'lg'}>
              A questo punto il cliente si reca allo stand e l'addetto scansiona il codice QR...
            </Text>
            <Button as='a' href={url} size={'lg'}>
              Scan!
            </Button>
          </HStack>
        </>
      )}
      <Footer />
    </Box>
  );
}

export default CheckoutOK;
